import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "flexSize", "isRecommended", "validationType"];
import React from 'react';
import { Field, useFormikContext } from 'formik';
import { StyledInput as CheggUiInput } from '../Shared/styled';
import { useInitialOrDefaultFieldValue } from '../../hooks/useInitialOrDefaultFieldValue';
import validationTypeToValidatorMapper, { InputValidationName } from '../validators';
export var Input = function Input(_ref) {
  var _values$pubtype, _values$pubtype2;
  var name = _ref.name,
    flexSize = _ref.flexSize,
    isRecommended = _ref.isRecommended,
    _ref$validationType = _ref.validationType,
    validationType = _ref$validationType === void 0 ? '' : _ref$validationType,
    restProps = _objectWithoutProperties(_ref, _excluded);
  useInitialOrDefaultFieldValue(name, '');
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var fieldPubType = name.split('.')[0];
  var pubtypeSuffix = values === null || values === void 0 ? void 0 : (_values$pubtype = values.pubtype) === null || _values$pubtype === void 0 ? void 0 : _values$pubtype.suffix;
  var pubtypeMain = values === null || values === void 0 ? void 0 : (_values$pubtype2 = values.pubtype) === null || _values$pubtype2 === void 0 ? void 0 : _values$pubtype2.main;
  var fieldValidator = validationTypeToValidatorMapper[validationType];
  /** if field pubtype matches either pubtype.main or pubtype.suffix
   * we will run validations on that field
   */
  var shouldValidationRunForField = function shouldValidationRunForField(fieldValue) {
    if (pubtypeSuffix === fieldPubType || pubtypeMain === fieldPubType) {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      return !!(fieldValidator && fieldValidator(fieldValue));
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: function validate(val) {
      if (shouldValidationRunForField(val)) return fieldValidator(val);
    }
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form,
      meta = _ref2.meta;
    return /*#__PURE__*/React.createElement(CheggUiInput, _extends({}, restProps, {
      flexSize: flexSize,
      isRecommended: isRecommended,
      inputId: name,
      value: field.value || '',
      onChange: function onChange(val) {
        return form.setFieldValue(name, val);
      },
      errorText: meta.error || '',
      onBlur: function onBlur(e) {
        var value = e.target.value;
        var isSingleDigitNumber = value.length === 1 && !Number.isNaN(+value) && value !== '0';
        if (validationType === InputValidationName.DAY && isSingleDigitNumber) {
          value = '0' + value; // make day double digit if single entered
          form.setFieldValue(name, value);
        }
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (fieldValidator) {
          form.setFieldError(name, fieldValidator(value));
        }
      }
    }));
  });
};